/**
 * @param address {string}
 */
export function formatAddress(address) {
  return address.slice(0, 5) + "..." + address.slice(-3)
}

export function formatFilename(fileName, lengthDisplayed) {
  if (fileName.length > lengthDisplayed) {
    const firstPartLength = lengthDisplayed / 2
    const middlePart = "..."
    const lastPartLength = lengthDisplayed / 2 - middlePart.length
    return `${fileName.slice(0, firstPartLength)}${middlePart}${fileName.slice(
      -lastPartLength,
    )}`
  } else {
    return fileName
  }
}

/**
 * @param name {string}
 * @param inputs {array}
 * @returns {string}
 */
export function formatFunctionNameWithParams(name = "", inputs = []) {
    return `${name} (${inputs.map(({type}) => type).join(", ")})`
}
  